import { createHttpLink } from '@apollo/client';

export const httpLink = createHttpLink({
	uri: import.meta.env.VITE_ODCO_GRAPHQL_BASE_URL,
	credentials: 'include',
	headers: {
		'Content-Type': 'application/json'
	}
});
